<template>
  <div class="row clearfix g-3">
    <div class="col-xl-12 col-lg-12 col-md-12 mb-3">
      <!-- Year Selector aligned to the right -->
      <div class="d-flex justify-content-end align-items-center">
        <p class="mt-3" style="margin-right:25px;">Έτος: </p>
        <select
          id="yearSelect"
          class="form-select form-select-sm"
          v-model="selyear"
          @change="handleYearChange"
          style="width: auto; min-width:140px"
        >
          <!-- Add option for "Όλα τα έτη" -->
          <option value="0">Όλα τα έτη</option>
          <!-- Existing year options -->
          <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
        </select>
      </div>
    </div>

    <div class="col-xl-8 col-lg-8 col-md-8  justify-content-center align-items-center" style="margin-left:15%">

      <div class="row row-cols-1 row-cols-md-2">
        <div class="col-md-6 mb-4">
          <div class="card">
            <div class="card-body text-center">
              <h5 class="card-title">Εφαρμοσμένα Μοσχεύματα</h5>
              <p class="card-text" style="color:#00cc00">{{ data.hospuse || 0 }}</p>
            </div>
          </div>
        </div>
        <div class="col-md-6 mb-4">
          <div class="card" style="background-color: #ff9900;">
            <div class="card-body text-center">
              <h5 class="card-title" style="color:white">Ληγμένα μοσχεύματα</h5>
              <p class="card-text" style="color:white">{{ data.cntrexpired || 0 }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="row row-cols-1 row-cols-md-2">
        <div class="col-md-6 mb-4">
          <div class="card ">
            <div class="card-body text-center">
              <h5 class="card-title">Μοσχεύματα προς εφαρμογή</h5>
              <p class="card-text" style="color:#ff3300">{{ data.nohospcount || 0 }}</p>
            </div>
          </div>
        </div>
        <div class="col-md-6 mb-4">
          <div class="card" >
            <div class="card-body text-center">
              <h5 class="card-title">Δηλωθέντα Μοσχεύματα</h5>
              <p class="card-text" style="color:#3399cc">{{ data.totcount || 0 }}</p>
            </div>
          </div>
        </div>
        
      </div>
     
    </div>
  </div>
</template>

<script>
import router from "@/router";
import ApexCharts from "apexcharts";
import { useToast } from "vue-toastification";
import apiClient from "@/services/api";
import { mapGetters } from "vuex";
import { fetchUserInfo } from "@/services/institutions";

export default {
  data() {
    const currentYear = new Date().getFullYear();
    return {
      selyear: currentYear.toString(),
      years: Array.from({ length: 5 }, (_, i) => (currentYear - i).toString()),
      data: {},
    };
  },
  computed: {
    ...mapGetters({
      getUserPermission: "getUserPermission",
      getSuperUserPermission: "getSuperUserPermission",
    }),
    superUser() {
      return this.getSuperUserPermission === 1;
    },
  },
  methods: {
    async fetchStatistics(instId) {
      const response = await apiClient.get(
        `/eomws/getinstdashperyear/?selyear=${this.selyear}&instid=${instId}`
      );
      return response;
    },
    async handleYearChange() {
      try {
        const currentUser = await fetchUserInfo();
        const response = await this.fetchStatistics(currentUser.data.institution.id);
        this.data = response.data.data || {};
      } catch (error) {
        console.error("Error fetching statistics for selected year:", error);
      }
    },
  },
  async mounted() {
    try {
      const currentUser = await fetchUserInfo();
      const response = await this.fetchStatistics(currentUser.data.institution.id);
      this.data = response.data.data || {};
    } catch (error) {
      console.error("Error fetching statistics:", error);
    }
  },
};
</script>


<style scoped>
.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.card {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  border-radius: 10px;
    background-color: #f2f2f2;
    height: 100px; /* Fixed height for all cards */

    
}
.card-title {
  font-weight: bold;
  font-size: 20px;
    color: #ccc;
}

.card-text {
  font-weight: bold;
  font-size: 20px;
 
}
.form-select-sm {
  font-size: 0.875rem;
  padding: 0.25rem 0.5rem;
}
</style>
